import { observer } from 'mobx-react';
import ScrollToTop from '../../../../../../ScrollToTop';
import ModalStore from '../../../../../Modal/Store';
import BackButton from '../../../LearningCollectionSteps/BackButton';
import ExeconlineCatalogDetails from '../../../CurrentCollectionStep/Builder/ExeconlineCatalogDetails';
import LearningCollectionDetails from '../../../CurrentCollectionStep/Builder/LearningCollectionDetails';
import VideoProjectFeedbackDetails from '../../../CurrentCollectionStep/Builder/VideoProjectFeedbackDetails';
import ContinueButton from '../../../LearningCollectionSteps/ContinueButton';
import Navigation from '../Navigation';
import LearningCollectionEditStore from '../../Store';
import { CustomizeState } from '../../Store/Types';
import Programs from './Programs';

interface Props {
  store: LearningCollectionEditStore;
  state: CustomizeState;
}

function Builder({ store, state }: Props) {
  const videoProjectFeedbackModalStore: ModalStore = new ModalStore();
  const execonlineCatalogModalStore: ModalStore = new ModalStore();

  const warnUser = () =>
    store.learningCollectionEditFormResource
      .map((editFormResource) => editFormResource.payload.browseAll)
      .getOrElseValue(false) && store.browseAll;

  return (
    <>
      <ScrollToTop />
      <div>
        <Navigation store={store}>
          <BackButton handleOnClick={() => store.editingDetails(state.celebrationPage)} />
          <ContinueButton handleOnClick={store.saving} disabled={!store.canSave} />
        </Navigation>
        <div className="mx-auto max-w-clientPortalMaxWidth px-2.5 pb-4 pt-16 md:flex-row lg:px-12">
          <LearningCollectionDetails
            store={store}
            state={state}
            warnUser={warnUser}
            videoProjectFeedbackModalStore={videoProjectFeedbackModalStore}
            execonlineCatalogModalStore={execonlineCatalogModalStore}
          />
          <hr className="mb-6 border-gray-200" />
          <Programs store={store} state={state} />
        </div>
      </div>
      <VideoProjectFeedbackDetails modalStore={videoProjectFeedbackModalStore} />
      <ExeconlineCatalogDetails modalStore={execonlineCatalogModalStore} />
    </>
  );
}

export default observer(Builder);
